import { isIOS } from "../platform.js";
import { findClosestScrollableContainer } from "../dom/index.js";
import lockSafariScroll from "./lockSafari.js";
import lockStandardScroll from "./lockStandard.js";
let bodyLockedCount = 0;
let reset = () => { };
export const lockScroll = (args) => {
    const isIOSLock = isIOS() && !args.containerEl && !args.originEl;
    let container = document.body;
    if (args.originEl && !isIOSLock) {
        container = findClosestScrollableContainer({ el: args.originEl });
    }
    if (args.containerEl && !isIOSLock)
        container = args.containerEl;
    if (container === document.body)
        bodyLockedCount += 1;
    if (bodyLockedCount > 1)
        return;
    if (isIOSLock) {
        reset = lockSafariScroll();
    }
    else {
        reset = lockStandardScroll({ container });
    }
    args.cb?.();
};
export const unlockScroll = (cb) => {
    bodyLockedCount -= 1;
    if (bodyLockedCount > 0)
        return;
    reset();
    cb?.();
};
